import { withIcon } from "../Icon"

export const IconCross = withIcon(
  '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m16 8-8 8m0-8 8 8"/>',
)
